<kendo-buttongroup class="w-100 mb-4" selection="single">
  <button class="w-50" kendoButton [togglable]="true" (click)="select('email')" [selected]="selected == 'email'">
    Mot de passe
  </button>
  <button class="w-50" kendoButton [togglable]="true" (click)="select('sms')" [selected]="selected == 'sms'">
    SMS
  </button>
</kendo-buttongroup>



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/login/components/login-nav/login-nav.component.html